<template>
  <div class="measurement-controls">
    <div v-if="hasDeviceCalibrations">
      <label class="modal-label">Select Calibration</label>
    </div>
    <select-with-button
      v-if="hasDeviceCalibrations"
      :value="calibration"
      @input="updateCalibration"
      :items="deviceCalibrations"
      item-text="desc"
      item-value="desc"
      name="what"
      :hide-details="true"/>
    <div class="warning-text">{{this.warningMessage}}</div>
    <div v-if="deviceCalibration">
      <v-row>
        <v-col class="text-center">
          <annotation-mode-button
            :image="coloredAssetUrls.line"
            :activeImage="activeAnnotationIcons.line"
            title="Line"
            @click="annotationModeButtonClick(annotationModes.LengthLine)"
            :buttonMode="annotationModes.LengthLine"
            :annotationMode="annotationMode"/>
          <annotation-mode-button
            :image="coloredAssetUrls.area"
            :activeImage="activeAnnotationIcons.area"
            title="Area"
            @click="annotationModeButtonClick(annotationModes.Area)"
            :buttonMode="annotationModes.Area"
            :annotationMode="annotationMode"/>
          <annotation-mode-button
            :image="coloredAssetUrls.cupToDisc"
            :activeImage="activeAnnotationIcons.cupToDisc"
            title="Cup To Disc"
            @click="annotationModeButtonClick(annotationModes.CupToDisc)"
            :buttonMode="annotationModes.CupToDisc"
            :annotationMode="annotationMode"/>
          <annotation-mode-button
            :image="coloredAssetUrls.freehandArea"
            :activeImage="activeAnnotationIcons.freehandArea"
            title="Free Hand Area"
            @click="annotationModeButtonClick(annotationModes.FreeHandArea)"
            :buttonMode="annotationModes.FreeHandArea"
            :annotationMode="annotationMode"/>
          <annotation-mode-button
            :image="coloredAssetUrls.pdt"
            :activeImage="activeAnnotationIcons.pdt"
            title="PDT"
            @click="annotationModeButtonClick(annotationModes.PDT)"
            :buttonMode="annotationModes.PDT"
            :annotationMode="annotationMode"/>
          <annotation-mode-button
            :image="coloredAssetUrls.etdrs"
            :activeImage="activeAnnotationIcons.etdrs"
            title="ETDRS Grid"
            @click="annotationModeButtonClick(annotationModes.ETDRSGrid)"
            :buttonMode="annotationModes.ETDRSGrid"
            :annotationMode="annotationMode"/>
          <annotation-mode-button
            :image="coloredAssetUrls.smallStandardCircles"
            :activeImage="activeAnnotationIcons.smallStandardCircles"
            title="Standard Circles C0, C1, C2"
            @click="annotationModeButtonClick(annotationModes.StandardCircles1)"
            :buttonMode="annotationModes.StandardCircles1"
            :annotationMode="annotationMode"/>
          <annotation-mode-button
            :image="coloredAssetUrls.standardCircles"
            :activeImage="activeAnnotationIcons.standardCircles"
            title="Standard Circles C3, C4"
            @click="annotationModeButtonClick(annotationModes.StandardCircles2)"
            :buttonMode="annotationModes.StandardCircles2"
            :annotationMode="annotationMode"/>
          <annotation-mode-button
            :image="coloredAssetUrls.smallDrusenCircles"
            :activeImage="activeAnnotationIcons.smallDrusenCircles"
            title="Drusen Circles C-0, C-1, C-2"
            @click="annotationModeButtonClick(annotationModes.DrusenCircles1)"
            :buttonMode="annotationModes.DrusenCircles1"
            :annotationMode="annotationMode"/>
          <annotation-mode-button
            :image="coloredAssetUrls.drusenCircles"
            :activeImage="activeAnnotationIcons.drusenCircles"
            title="Drusen Circles I-2, O-2"
            @click="annotationModeButtonClick(annotationModes.DrusenCircles2)"
            :buttonMode="annotationModes.DrusenCircles2"
            :annotationMode="annotationMode"/>
          <annotation-mode-button
            :image="coloredAssetUrls.drusenHalf"
            :activeImage="activeAnnotationIcons.drusenHalf"
            title="Drusen Circles ½ DA"
            @click="annotationModeButtonClick(annotationModes.DrusenCircles3)"
            :buttonMode="annotationModes.DrusenCircles3"
            :annotationMode="annotationMode"/>
          <annotation-mode-button
            :image="coloredAssetUrls.drusenCircle"
            :activeImage="activeAnnotationIcons.drusenCircle"
            title="Drusen Circles 1 DA"
            @click="annotationModeButtonClick(annotationModes.DrusenCircles4)"
            :buttonMode="annotationModes.DrusenCircles4"
            :annotationMode="annotationMode"/>
          <annotation-mode-button
            :image="coloredAssetUrls.rectangle"
            :activeImage="activeAnnotationIcons.rectangle"
            title="Rectangle"
            @click="annotationModeButtonClick(annotationModes.Rectangle)"
            :buttonMode="annotationModes.Rectangle"
            :annotationMode="annotationMode"/>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { ANNOTATION_MODES } from "../../../config/config";
import selectWithButton from "../../controls/SelectWithButton";
import annotationModeButton from "./AnnotationModeButton";
import imageAnnotationHelper from "../../mixins/ImageAnnotationHelper";
export default {
  name: "ImageMeasurementControls",
  components: { selectWithButton, annotationModeButton },
  data() {
    return {
      annotationModes: ANNOTATION_MODES
    };
  },
  props: ["context"],
  mixins: [imageAnnotationHelper],
  computed: {
    ...mapGetters([
      "annotationMode",
      "exam",
      "deviceCalibration",
      "hasDeviceCalibrations",
      "deviceCalibrations"
    ]),
    calibration() {
      return this.deviceCalibration;
    },
    warningMessage() {
      return this.deviceCalibration
        ? ""
        : this.hasDeviceCalibrations
        ? "Please select proper calibration setting to enable measurements."
        : "";
    }
  },
  methods: {
    updateCalibration(value) {
      this.$store.commit("selectCalibration", value);
    },
    currentMode(mode) {
      return this.annotationMode == mode;
    }
  }
};
</script>

<style lang="scss" scoped>
.warning-text {
  color: yellow;
}
</style>
